import { Component, Input, OnDestroy, OnInit, QueryList, ViewChildren, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { ComboBoxComponent } from '@progress/kendo-angular-dropdowns';
import { FileToImport, MapFields } from '~/front-models/fileToImport';
import { ImportComponent } from '../import.component';
import { ImportService } from '~/services/modules/stocks/import';
import { ThemeManagerService } from '~/services/theme-manager';
import { UserSummary } from '~/models/administration/user';
import { SecurityService } from '~/services/security.service';
import { FundingSourceSettingsService } from '~/services/administration.ts/fundingSourceSettings';

@Component({
    selector: 'stocks-import-map-fields',
    templateUrl: './map-fields.html',
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'stocks-import-map-fields',
    },
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ImportMapFieldsComponent implements OnInit, OnDestroy {
  _importUpsertSetting = 'new';
  _importUpsertSettingCheckBox = false;
  _mapFieldsData: MapFields[] = [];
  _listExcelHeaders: string[] = [];
  @Input() _selectedModel: FileToImport;
  @Input() _CopySelectedModelsColumns: any = [];
  @Input() _StockLocationMinMaxFields: any = [];
  @Input() _AssignAssetFields: any = [];
  @Input() _mappedFields: any = [];
  _fileExcelData: any;
  selectedColumnsCopy: any = [];
  AllStockItemColumns: any = [];
  @ViewChildren('your_fields') yourFieldsCombo: QueryList<ComboBoxComponent>;
  _currentUser: UserSummary;
  @Input() ImportMapList: any = [];

  ImportMapItem: any;

  _theme: string;

  showEditDeleteMapDialog: boolean = false;


  constructor(private _importComponent: ImportComponent, private _importService: ImportService,
    private _fundingSourceSettingService: FundingSourceSettingsService
    , private _securityService: SecurityService, private _themeManager: ThemeManagerService) {
    this._currentUser = this._securityService.currentUser;
    this._themeManager.themeChange.subscribe((data) => {
      this._theme = data;
    });
  }
  fundingSourceSettingEnabled: boolean
  ngOnInit() {
    // if(this._mappedFields && this._mappedFields.length > 0)
    // this._mapFieldsData = this._mappedFields;
    //Temp
    //this._importComponent.importObject.importUpsertSetting = 'update';
    this._fundingSourceSettingService.getFundingSourceSettings().subscribe((data) => {//start
      this.fundingSourceSettingEnabled = data ? data.enabled : false;
      if (this.fundingSourceSettingEnabled == true) {
        // this._mapFieldsData = this._mapFieldsData
      }
    });//end

    this._importUpsertSetting = this._importComponent.importObject.importUpsertSetting;
    this._fileExcelData = this._importComponent.fileExcelData;
    if (this._importUpsertSetting == "treatAsReceiveTransaction") {
      this._importUpsertSettingCheckBox = true;
    }

    this._importService.isMapSaved.subscribe(x => {
      this.getImpoertedList();
    });

    this._initExcelHeader();
    if (this._importUpsertSetting != 'alternateStockItem') {
      this._initMapFieldsData(this._mappedFields);
      this._importUpsertSettingChanged(this._importUpsertSetting);
    }
    if (this._importUpsertSetting == 'alternateStockItem') {
      this._selectedModel.columns = this._CopySelectedModelsColumns;
      this._importUpsertSettingChanged(this._importUpsertSetting);
    }
    // setTimeout(() => {
    //   this.yourFieldsCombo['_results'][0].toggle(true);
    //   this.yourFieldsCombo['_results'][0].focus();
    // });

    this.getImpoertedList();
  }

  ngOnDestroy() {

  }
  openEditDeleteDialog() {
    this.showEditDeleteMapDialog = true;
  }
  closeEditDeleteDialog() {
    this.showEditDeleteMapDialog = false;
  }

  editSavedMap() {

  }
  deleteSavedMap() {

  }

  getImpoertedList() {
    this._importService.getImportNames().subscribe((data: Array<any>) => {
      this.ImportMapList = data;
      if (this._importService.savedMapItem) {
        this.ImportMapItem = this._importService.savedMapItem;
      }
    });
  }
  _importUpsertSettingChanged(importUpsertSetting: string) {
    this._importComponent.importObject.importUpsertSetting = importUpsertSetting;
    if (this._selectedModel.labelName == "stockItems" || this._selectedModel.labelName == "assets") {
      if (this._selectedModel.labelName == "stockItems"
        && this._importUpsertSetting != "alternateStockItem") {
        this._selectedModel.columns = [...this._CopySelectedModelsColumns.filter((x: any) => x.label != "master stock number")];
      }
      else {
        this._selectedModel.columns = [...this._CopySelectedModelsColumns];
      }

      if (this._importUpsertSetting == "alternateStockItem") {
        this._mappedFields = [];
        this._selectedModel.columns = [...this._CopySelectedModelsColumns.filter((x: any) => x.label == "master stock number" || x.label == "Stock Item #")]
      }
      if (this._importUpsertSetting == "locationMinMax") {
        this._mappedFields = [];
        this._selectedModel.columns = this._CopySelectedModelsColumns.filter((x: any) => x.label == "Stock Item #")
        this._StockLocationMinMaxFields.forEach((element: any) => {
          this._selectedModel.columns.push(element);
        });

      }
      if (this._importUpsertSetting == "assignedAssets") {
        this._mappedFields = [];
        //this._selectedModel.columns = this._CopySelectedModelsColumns.filter((x: any) =>  x.label == "Stock Item #" )
        this._AssignAssetFields.forEach((element: any) => {
          this._selectedModel.columns.push(element);
        });

      }
      this._mapFieldsData = [];
      this._initMapFieldsData(this._mappedFields);

    }


  }

  _handleSavedMapChange(event: any) {
    if (event) {
      this._importService.savedMapItem = event;
      this._mappedFields = [];
      this._importComponent.updateImportObject([]);
      event.importMappDetailUpdateModel.forEach((element: any) => {
        let loadSavedMapObject = {
          importMapId: 0,
          barcloudField: element.fieldName,
          barcloudLabel: this._selectedModel.columns.find(x =>
            x.name == element.fieldName
          )?.label,
          barcloudMappedName: this._selectedModel.columns.find(x =>
            x.name == element.fieldName
          )?.mappedName,
          // barcloudLabel:  element.gridFieldText,
          // barcloudMappedName : this._selectedModel.columns.find(x => x.field == element.fieldName).mappedName,
          importedField: element.excelName,
          required: this._selectedModel.columns.find(x => x.field == element.fieldName)?.required
        }
        this._mappedFields.push(loadSavedMapObject);
      });
      this._initMapFieldsData(this._mappedFields);
    }
    this._importComponent.updateMappedFields(this._mappedFields);
    this._importService.importedItem = event;
  }

  _importUpsertSettingCheckboxChanged(value: boolean) {
    if (value)
      this._importUpsertSettingChanged('treatAsReceiveTransaction');
    else
      this._importUpsertSettingChanged('new');

  }
  _initMapFieldsData(SavedMap: any = null) {
    this._mapFieldsData = [];
    //this._selectedModel = this._importComponent.selectedModel;
    for (const column of this._selectedModel.columns) {
      const fieldObject = {
        barcloudField: column.name,
        barcloudLabel: column.label,
        barcloudMappedName: column.mappedName,
        importedField: '',
        required: column.required,
      };


      if (SavedMap && SavedMap.length > 0) {
        this._mapFieldsData.push(fieldObject);
        // check if column name is in Saved Map
        var CheckSavedMap = SavedMap.find((x: any) => x.barcloudLabel == column.label && x.importedField);
        if (CheckSavedMap) {
          this._importedFieldSelected(column.mappedName, column.label, -1, true, CheckSavedMap.importedField);
          // fieldObject.importedField = CheckSavedMap.importedField;
        }
        else {
          column.mappedNameToValidate = '';
        }


      }
      else {
        this._mapFieldsData.push(fieldObject);
        // check if column name equal excel field name
        var CompareExcelHeader = this._listExcelHeaders.find((x) => x.toLocaleLowerCase().trim() === column.mappedName.toLocaleLowerCase().trim());

        if (CompareExcelHeader) {
          this._importedFieldSelected(column.mappedName, column.label, -1, true, CompareExcelHeader);
          // fieldObject.importedField = CompareExcelHeader;
        }
        else {
          column.mappedNameToValidate = '';
        }

        this._mappedFields = this._mapFieldsData;
        this._importComponent.updateMappedFields(this._mappedFields);
      }



    }
    this._checkIfCanValidate();

  }

  _initExcelHeader() {
    const firstItem = this._fileExcelData[0];

    for (const key in firstItem) {
      if (Object.prototype.hasOwnProperty.call(firstItem, key)) {
        this._listExcelHeaders.push(key);
      }
    }
  }

  // _importedFieldSelected(e: string, columnName: string, rowIndex: any = -1, FromTs: boolean) {

  //   // if(FromTs)
  //   // {
  //   //   const columnToUpdate = this._selectedModel.columns.find(
  //   //     (x: any) => x.label === e)
  //   //   columnToUpdate.mappedName = e;

  //   // }
  //   // else
  //   // {
  //   //   const columnToUpdate = this._selectedModel.columns.find(
  //   //     (x: any) => x.label.toLowerCase().trim() === columnName.toLowerCase().trim()
  //   //   );
  //   //   columnToUpdate.mappedName = e;
  //   // }
  //   //if(!FromTs)
  //   //{
  //         const columnToUpdate = this._selectedModel.columns.find(
  //       (x: any) => x.mappedName === e)
  //     columnToUpdate.mappedName = e;

  //     const importedField =  this._mapFieldsData.find(
  //       (x: any) => x.barcloudLabel === columnName
  //     );
  //     importedField.importedField = e;
  //     this._importComponent.updateSelectedModel(this._selectedModel);
  //   //}


  //   this._checkIfCanValidate();
  //   // if(this._selectedModel.columns.find((x: any) => !x.mappedName && x.required))
  //   // {
  //   //   this._importComponent.setCanGoNext(false);
  //   // }
  //   // else
  //   // {
  //   //   this._importComponent.setCanGoNext(true);
  //   // }


  //   if (rowIndex > -1 && ((rowIndex + 1) < this.yourFieldsCombo['_results'].length)) {
  //     setTimeout(() => {
  //       // this.yourFieldsCombo['_results'][parseInt(rowIndex) + 1].toggle(true);
  //       // this.yourFieldsCombo['_results'][parseInt(rowIndex) + 1].focus();
  //     });

  //   }

  // }

  test(event: any) {
  }
  deleteMap(event: any) {
    this._importService.deletetMap(event.id).subscribe((data) => {
      this.getImpoertedList();
    });
  }
  editMap(event: any) {
    let importMappDetailModel: any[] = [];
    this._mappedFields.forEach((element: any) => {
      let mapDetailObject = {
        importMapId: 0,
        fieldName: element.barcloudField,
        gridFieldText: element.barcloudMappedName,
        excelName: element.importedField,
      }
      importMappDetailModel.push(mapDetailObject);
    });
    event.importMappDetailUpdateModel = importMappDetailModel;
    this._importService.edittMap(event.id, event).subscribe((data) => {
      this.getImpoertedList();
    });
  }

  _importedFieldSelected(e: string, columnName: string, rowIndex: any = -1, FromTs: boolean, CompareExcelHeader: string = '') {

    const columnToUpdate = this._selectedModel.columns.find(
      (x: any) => x.label === columnName)
    //columnToUpdate.mappedName = e;
    if (CompareExcelHeader)
      columnToUpdate.mappedNameToValidate = CompareExcelHeader;
    else
      columnToUpdate.mappedNameToValidate = e;

    const importedField = this._mapFieldsData.find(
      (x: any) => x.barcloudLabel === columnName
    );
    if (CompareExcelHeader)
      importedField.importedField = CompareExcelHeader;
    else
      importedField.importedField = e;
    this._importComponent.updateSelectedModel(this._selectedModel);
    //}
    if (!CompareExcelHeader) {
      this._mappedFields = [...this._mapFieldsData];
      this._importComponent.updateMappedFields(this._mappedFields);
    }

    this._checkIfCanValidate();



    if (rowIndex > -1 && ((rowIndex + 1) < this.yourFieldsCombo['_results'].length)) {
      setTimeout(() => {
        // this.yourFieldsCombo['_results'][parseInt(rowIndex) + 1].toggle(true);
        // this.yourFieldsCombo['_results'][parseInt(rowIndex) + 1].focus();
      });

    }

  }

  _checkIfCanValidate() {

    var CheckRequiredNotSelected = this._mapFieldsData.find((x: any) => !x.importedField && x.required);
    if (CheckRequiredNotSelected) {
      this._importComponent.setCanGoNext(false);
    }
    else {
      this._importComponent.setCanGoNext(true);
    }
    // if (this._selectedModel.columns.find((x: any) => x.mappedName)) {


    //     this._importComponent.setCanGoNext(true);
    // } else {
    //   this._importComponent.setCanGoNext(false);
    // }
  }
}
